import { useState, useRef, useCallback } from "react";

export const ResizablePanel = ({
    defaultWidth,
    maxWidth,
    minWidth,
    onDragStart,
    onDragEnd,
    children,
}) => {
    const [rightPanelWidth, setRightPanelWidth] = useState(defaultWidth);
    const [isDragging, setIsDragging] = useState(false);
    const dragStartX = useRef(0);
    const startWidth = useRef(0);

    const handleMouseMove = useCallback(
        (e) => {
            const deltaX = dragStartX.current - e.clientX;
            const newWidth = startWidth.current + deltaX;

            if (newWidth >= minWidth && newWidth <= maxWidth) {
                setRightPanelWidth(newWidth);
            }
        },
        [minWidth, maxWidth]
    );

    const handleMouseUp = useCallback(() => {
        setIsDragging(false);
        onDragEnd?.();
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
    }, [handleMouseMove, onDragEnd]);

    const handleMouseDown = (e) => {
        setIsDragging(true);
        onDragStart?.();
        dragStartX.current = e.clientX;
        startWidth.current = rightPanelWidth;
        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
        e.preventDefault();
    };
    return (
        <>
            {/* Draggable resize handle */}
            <div
                className={`cursor-col-resize bg-gray-300 hover:bg-gray-400 transition-colors duration-150 flex items-center justify-center ${
                    isDragging ? "bg-gray-500" : ""
                }`}
                style={{
                    width: "4px",
                    height: "calc(100vh - 56px)",
                    userSelect: "none",
                    cursor: "col-resize",
                }}
                title="Drag to resize"
                onMouseDown={handleMouseDown}
            >
                <div className="w-1 h-8 bg-gray-500 rounded-full opacity-60"></div>
            </div>

            <div style={{ width: `${rightPanelWidth}px` }}>{children}</div>
        </>
    );
};
